// extracted by mini-css-extract-plugin
export default {"page":"rZ-z","cartModal":"sZ-z","checkout":"tZ-z","placeholder":"uZ-z","account":"vZ-z"};